import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faQrcode, faX, faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import './successqr.css';

const SuccessModal = ({ isOpen, onClose, showQrHint, isRecreation = false, onViewQrCode }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleClose = () => {
    if (isRecreation && onViewQrCode) {
      // Se é recreation e tem callback, fecha este modal e abre o de QR Code
      if (onClose) onClose();
      onViewQrCode();
    } else {
      // Comportamento normal
      if (onClose) onClose();
      if (!isRecreation) {
        navigate('/');
      }
    }
  };

  return (
    <div className="success-modal-overlay">
      <div className="success-modal-backdrop" onClick={handleClose}></div>
      <div className={`success-modal ${isRecreation ? 'recreation' : ''}`}>
        <button className="success-modal-close" onClick={handleClose}>
          <FontAwesomeIcon icon={faX} />
        </button>
        
        <div className="success-modal-content">
          <div className={`success-icon-container ${isRecreation ? 'recreation-icon' : ''}`}>
            <FontAwesomeIcon 
              icon={isRecreation ? faArrowsRotate : faCheckCircle} 
              className="success-icon" 
            />
          </div>
          
          <h2 className="success-title">
            {isRecreation 
              ? (t('successqr.recreationTitle') || "Instância Recriada!")
              : (t('successqr.title') || "Instância Criada e Reiniciada!")
            }
          </h2>
          
          <p className="success-message">
            {isRecreation 
              ? (t('successqr.recreationMessage') || "Sua instância foi reiniciada com sucesso e está pronta para nova conexão.")
              : (t('successqr.message') || "Sua instância foi criada, reiniciada e está pronta para conexão.")
            }
          </p>
          
          {showQrHint && (
            <div className="success-hint">
              <div className="hint-icon">
                <FontAwesomeIcon icon={faQrcode} />
              </div>
                             <div className="hint-content">
                 <span className="hint-title">
                   {isRecreation ? "Nova Conexão" : "Próximo passo"}
                 </span>
                 <span className="hint-text">
                   {isRecreation 
                     ? (t('successqr.recreationHint') || "A instância foi reiniciada. Escaneie o novo QR Code para reconectar.")
                     : (t('successqr.qrHint') || "Agora você será redirecionado para escanear o QR Code e conectar sua instância.")
                   }
                 </span>
               </div>
            </div>
          )}
          
          <div className="success-actions">
                         <button className="success-button" onClick={handleClose}>
               <span>
                 {isRecreation 
                   ? (t('successqr.recreationButton') || "Ver Novo QR Code")
                   : (t('successqr.close') || "Continuar para QR Code")
                 }
               </span>
             </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;